import React from "react";
import "./BlogCard.css";

const BlogCard = ({ imagePath, date, heading, subtext }) => {
  return (
    <div className="blog-card">
      <div className="image-container">
        <img src={imagePath} alt={heading} className="blog-image" />
      </div>
      <div className="blog-content">
        <p className="blog-date-card">{date}</p>
        <h3 className="blog-heading">{heading}</h3>
        <p className="blog-subtext">{subtext}</p>
        <div className="separator-line"></div>
        <div className="read-more">READ MORE</div>
      </div>
    </div>
  );
};

export default BlogCard;
